import React, { useContext, useState } from 'react';
import { motion } from 'framer-motion';
// import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import logo from '../../images/logo.png';
import {FaEyeSlash} from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { showSwalNotification } from '../../utils/SwalResponse';
import LoadingComponent from '../../utils/LoadingComponent';
import { evaluatePasswordStrength } from '../../utils/passwords';

const forestGreen = '#228B22';

const PasswordReset = () => {
  const {userId} = useParams()
  const {resetPassword,loading} = useContext(AuthContext)
  const navigate = useNavigate()
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

 
  const passwordStrength = evaluatePasswordStrength(password);

  const getStrengthColor = (score) => {
    if (score < 40) return '#dc3545';   // red
    if (score < 60) return '#fd7e14';   // orange
    if (score < 80) return '#ffc107';   // yellow
    return '#28a745';                   // green
  };


  const passwordsMatch = password === confirm;
  const isStrongEnough = passwordStrength >= 80;


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!!userId){
      const response = await resetPassword({user_id:userId,password});
      if (response?.status === 'success'){
        navigate('/login') 
      }

      showSwalNotification(response)
    }
  };
  if(!!loading) return <LoadingComponent loadingText={'Reseting Your Password ....'}/>

  return (
    <motion.div
      className="d-flex bg-None justify-content-center align-items-center vh-100"
      // style={{ background: '#f8f9fa' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.div
        className="card p-4 m-3 shadow-lg"
        style={{
          width: '100%',
          maxWidth: '450px',
          borderRadius: '16px',
          border: `1px solid ${forestGreen}`,
          backgroundColor: 'rgb(225,225,225,0.5)',
        }}
        initial={{ y: 30, scale: 0.98 }}
        animate={{ y: 0, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        {/* Logo */}
        <div className="text-center mb-3">
          <img
            src={logo}
            alt="App Logo"
            style={{ width: '150px', height: 'auto' }}
          />
        </div>

        <h3
          className="text-center mb-3"
          style={{ color: 'darkGreen', fontWeight: 600, fontSize: '1.7rem' }}
        >
          Reset Your Password
        </h3>

        <form onSubmit={handleSubmit}>
          {/* New Password */}
          <motion.div className="form-group mb-3" whileFocus={{ scale: 1.02 }}>
            <label style={{ fontWeight: 500, color: '#333' }}>🔐 New Password</label>
            <div className="input-group">
              <input
                type={show ? 'text' : 'password'}
                name="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder='New Password'
                style={{ borderColor: forestGreen }}
              />
              <span className="input-group-text" onClick={() => setShow(!show)} style={{ cursor: 'pointer' }}>
                {show ? <FaEyeSlash /> : '👁️'}
              </span>
            </div>


            {/* Password Strength Bar */}
            {!!password && (<div className="mt-2">
              <div className="progress" style={{ height: '8px' }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${passwordStrength}%`,
                    backgroundColor: getStrengthColor(passwordStrength),
                  }}
                ></div>
              </div>
              <small className="text-muted">Password strength: {passwordStrength}%</small>
            </div>
          )}
          </motion.div>

          {/* Confirm Password */}
          <motion.div className="form-group position-relative mb-4">
            <label className="mb-1" style={{ fontWeight: 500 }}>
              🔁 Confirm Password
            </label>
            <div className="input-group">
              <input
                type={show ? 'text' : 'password'}
                name="password"
                className="form-control"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                style={{ borderColor: forestGreen }}
                required
                placeholder="Re-enter new password"
              />
              <span className="input-group-text" 
                onClick={() => setShowConfirm(!showConfirm)}
               style={{ cursor: 'pointer' }}>
                {showConfirm ? <FaEyeSlash /> : '👁️'}
              </span>
            </div>
           
            {!passwordsMatch && confirm.length > 0 && (
              <small className="text-danger">Passwords do not match</small>
            )}
          </motion.div>

          {/* Submit */}
          <motion.button
            type="submit"
            disabled={!isStrongEnough || !passwordsMatch}
            className="btn w-100"
            style={{
              backgroundColor: forestGreen,
              color: '#fff',
              fontWeight: 600,
              borderRadius: '8px',
              opacity: !isStrongEnough || !passwordsMatch ? 0.6 : 1,
              cursor: !isStrongEnough || !passwordsMatch ? 'not-allowed' : 'pointer',
            }}
            whileHover={{
              scale: !isStrongEnough || !passwordsMatch ? 1 : 1.02,
            }}
            whileTap={{ scale: 0.98 }}
          >
            Update Password
          </motion.button>
        </form>
      </motion.div>
    </motion.div>
  );
};

export default PasswordReset;
